import React from "react";
import Logo from "./Logo";
import tiolLogo from "../../assets/img/tiolLogo.png";
import { Link } from "react-router-dom";
import logo from "../../assets/img/mtLogo.png";

const COLS = [
  {
    h: "Platform",
    links: [
      ["AI Research", "/#platform"],
      ["Legal Insights", "/#insights"],
      ["Litigation & Alerts", "/#platform"],
      ["Draft Studio", "/#platform"],
    ],
  },
  {
    h: "Company",
    links: [
      ["About", "/#top"],
      ["Careers", "/#top"],
      ["Trust centre", "/#security"],
      ["Contact", "/#contact"],
    ],
  },
];

const Footer = () => (
  <footer className="vd-footer">
    <div className="container">
      <div className="row g-4">
        <div className="col-lg-6">
          {/* <Logo light /> */}
          <img src={logo} alt="Vedum" className="img-fluid vd-footer__logo" />
          <p className="mt-3 mb-2">
            Legal AI for research, litigation and drafting — built for India.
          </p>
          <small>In strategic partnership with</small>
          <br />
          <a
            className="vd-footer__tiol"
            href="https://www.taxindiaonline.com"
            target="_blank"
            rel="noreferrer"
          >
            <img src={tiolLogo} alt="TIOL — taxindiaonline.com" />
          </a>
        </div>
        {COLS.map((c) => (
          <div className="col-6 col-lg-3" key={c.h}>
            <h6>{c.h}</h6>
            <div className="vd-col">
              {c.links.map(([t, href]) => (
                <a key={t} href={href}>
                  {t}
                </a>
              ))}
            </div>
          </div>
        ))}
        {/* <div className="col-lg-4">
          <h6>Office</h6>
          <div className="vd-col">
            <span>[Street address]</span>
            <span>[City, State, PIN]</span>
            <span>[Phone] · [Email]</span>
          </div>
        </div> */}
      </div>
      <div className="vd-footer__bottom">
        <span>© {new Date().getFullYear()} Vedum. All rights reserved.</span>
        <span>
          <Link to="/privacy-policy">Privacy Policy</Link>
          {/* <a href="/#top">Terms</a> */}
          {/* <a href="/#top">Grievance officer</a> */}
        </span>
      </div>
      <p className="vd-footer__disclaimer">
        Vedum provides research and drafting assistance and does not provide
        legal advice. This website is not intended to solicit work.
      </p>
    </div>
  </footer>
);

export default Footer;
